import { createAsyncThunk } from '@reduxjs/toolkit';
import { storeResources } from '../../resources';
import { getClientPortalConfigurations } from '../../../services/ticketTemplates';
import { IDefaultError } from '../../types';
import { LabelValue } from '../../../types/common';

export const ThunkClientPortalConfigurations = createAsyncThunk<
  LabelValue[],
  undefined,
  { rejectValue: IDefaultError }
>(`${storeResources.TICKETS}/clientPortalConfigurations`, () =>
  getClientPortalConfigurations().then(res =>
    res.data.map(item => ({ label: item.name, value: item.id })),
  ),
);
